<template>
    <div class="cluster-options-wrapper">
        <div class="checked-all">
            <Checkbox name="allCheckBox" class="all-check" @valueChange="allCheckHandler" :data="allCheck" v-show="isShowAllCheck" />
            <label class="all-label" for="allCheckBox" v-show="isShowAllCheck">{{ allLabel }}</label>
        </div>
        <div class="cluster-operate-box">
            <component
                :is="btn.type || 'Button'"
                class="operator-button"
                v-for="(btn, idx) in buttons"
                :key="idx"
                @btnClick="btnClick(btn.id)"
                :text="btn.text"
            />
        </div>
    </div>
</template>

<script>
import Checkbox from "@/views/zhiji/bComponents/checks/Checkbox";
import Button from "@/views/zhiji/bComponents/buttons/Button";

export default {
    name: "ClusterOptions",
    props: ["allCheck", "config"],
    components: {
        Checkbox,
        Button
    },
    computed: {
        isShowAllCheck() {
            return true;
        },
        buttons() {
            return this.config.cardBottons || [];
        },
        allLabel() {
            return this.$t("zhiji.common.selectAll");
        }
    },
    methods: {
        allCheckHandler(data) {
            this.$emit("checkAllChange", data);
        },
        btnClick(item) {
            this.$emit("btnClick", item);
        }
    }
};
</script>

<style lang="scss" scoped>
.cluster-options-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 5px 12px 5px;
    border-top: 1px solid #e1eaf2;
    flex-wrap: wrap;
    font-size: 12px;

    .checked-all {
        display: flex;
        flex-direction: row;

        .all-label {
            margin-left: 5px;
        }
    }

    .cluster-operate-box {
        .operator-button {
            margin-right: 8px;
        }
    }
}
</style>
